import { render, staticRenderFns } from "./FormModalAssignment.vue?vue&type=template&id=c1a24f36&"
import script from "./FormModalAssignment.vue?vue&type=script&lang=js&"
export * from "./FormModalAssignment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports